import React from "react";
import {
  Modal,
  Typography,
  Button,
  Box,
  IconButton,
  ThemeProvider,
  createTheme,
  makeStyles,
} from "@material-ui/core";
import {
  Close as CloseIcon,
  LocationOn as LocationIcon,
  Save as SaveIcon,
  Cancel as CancelIcon,
} from "@material-ui/icons";
import GpsFixedIcon from "@material-ui/icons/GpsFixed";
import moment from "moment";
import useCommonStyles from "../CommanStyle/indexStyle";

const theme = createTheme({
  palette: {
    primary: { main: "#1976d2" },
    secondary: { main: "#f44336" },
  },
});

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(2),
  },

  paper: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 12,
    width: "100%",
    maxWidth: 1400,
    maxHeight: "95vh",
    overflow: "hidden",
  },

  /* ================= HEADER ================= */

  header: {
    background: "linear-gradient(135deg, #1e243c 0%, #003a6b 100%)",
    color: "#fff",
    borderRadius: "12px 12px 0 0",
  },

  headerTop: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "14px 20px",
    borderBottom: "1px solid rgba(255,255,255,0.12)",
  },

  headerTitle: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    fontSize: 18,
    fontWeight: 600,
  },

  closeButton: {
    color: "#fff",
  },

  infoRow: {
    display: "grid",
    // justifyContent: "space-between",
    // alignItems: "center",
    // alignItems: "center",
    gridTemplateColumns: "repeat(6, 1fr)",
    textAlign: "center",
    padding: "12px 10px",
  },

  infoBlock: {
    borderRight: "1px solid rgba(255,255,255,0.15)",
    "&:last-child": {
      borderRight: "none",
    },
  },

  label: {
    fontSize: 11,
    opacity: 0.75,
    letterSpacing: "1px",
  },

  value: {
    fontSize: 14,
    fontWeight: 600,
    marginTop: 4,
  },

  alertRed: {
    color: "#ff4d4f",
    fontWeight: 700,
  },

  /* ================= BODY ================= */

  content: {
    padding: theme.spacing(3),
    maxHeight: "calc(95vh - 200px)",
    overflowY: "auto",
  },

  actions: {
    padding: theme.spacing(2, 3),
    backgroundColor: "#f8f9fa",
    borderTop: "1px solid #e9ecef",
    display: "flex",
    justifyContent: "flex-end",
    gap: theme.spacing(1),
  },

  saveButton: {
    minWidth: 120,
    borderRadius: 25,
    textTransform: "none",
    fontWeight: 600,
    background: "linear-gradient(135deg, #2c3e50, #34495e)",
    color: "#fff",
  },

  cancelButton: {
    minWidth: 120,
    borderRadius: 25,
    textTransform: "none",
    fontWeight: 600,
  },
}));

export default function CommanModal({
  open,
  setOpen,
  handleSubmit,
  children,
  title,
  clearFeild = {},
  remarStatus,
  isShowTableData = false,
  vehicleData,
  satelitheCounte,
  getGpsDetails,
}) {
  const classes = useStyles();
  const commonClasses = useCommonStyles();

  const handleClose = () => {
    if (typeof clearFeild === "function") clearFeild();
    setOpen(false);
  };

  return (
    <ThemeProvider theme={theme}>
      <Modal open={open} onClose={handleClose} className={classes.modal}>
        <Box className={classes.paper}>
          {/* ================= HEADER ================= */}
          <Box className={classes.header}>
            <Box className={classes.headerTop}>
              <Box className={classes.headerTitle}>
                <LocationIcon />
                <Typography>{title}</Typography>
              </Box>

              <IconButton
                size="small"
                className={classes.closeButton}
                onClick={handleClose}
              >
                <CloseIcon />
              </IconButton>
            </Box>

            {isShowTableData && (
              <Box className={classes.infoRow}>
                <Box className={classes.infoBlock}>
                  <div className={classes.label}>VEHICLE NUMBER</div>
                  <div className={classes.value}>
                    {vehicleData?.vehicleNumber || "--"}
                  </div>
                </Box>

                <Box className={classes.infoBlock}>
                  <div className={classes.label}>AREA NAME</div>
                  <div className={classes.value}>
                    {vehicleData?.areaName || "--"}
                  </div>
                </Box>

                <Box className={classes.infoBlock}>
                  <div className={classes.label}>MINE NAME</div>
                  <div className={classes.value}>
                    {vehicleData?.vehicleData?.mineName || "--"}
                  </div>
                </Box>

                <Box className={classes.infoBlock}>
                  <div className={classes.label}>ALERT TYPE</div>
                  <div className={`${classes.value} ${classes.alertRed}`}>
                    {vehicleData?.alertType || "--"}
                  </div>
                </Box>

                <Box className={classes.infoBlock}>
                  <div className={classes.label}>ALERT TIME</div>
                  <div className={classes.value}>
                    {vehicleData?.serverTime
                      ? moment(vehicleData.serverTime).format(
                          "YYYY-MM-DD HH:mm:ss",
                        )
                      : "--"}
                  </div>
                </Box>
                <Box className={classes.infoBlock}>
                  <div className={classes.label}>SATELLITE COUNT</div>
                  <div className={classes.value}>
                    <span
                      style={{
                        color:
                          vehicleData?.satelitheCounte < 10 ? "red" : "green",
                      }}
                    >
                      {" "}
                      {vehicleData?.satelitheCounte
                        ? vehicleData?.satelitheCounte
                        : "--"}
                    </span>
                  </div>
                </Box>
              </Box>
            )}
          </Box>

          {/* ================= CONTENT ================= */}
          <Box>{children}</Box>

          {/* ================= ACTIONS ================= */}
          <Box className={classes.actions}>
            <Button
              variant="outlined"
              color="secondary"
              onClick={handleClose}
              startIcon={<CancelIcon />}
              className={classes.cancelButton}
            >
              Cancel
            </Button>
            {isShowTableData && (
              <Button
                variant="contained"
                onClick={getGpsDetails}
                startIcon={<GpsFixedIcon />}
                className={classes.saveButton}
              >
                Show Gps Details
              </Button>
            )}

            {remarStatus !== false && (
              <Button
                variant="contained"
                onClick={handleSubmit}
                startIcon={<SaveIcon />}
                className={classes.saveButton}
              >
                Save
              </Button>
            )}
          </Box>
        </Box>
      </Modal>
    </ThemeProvider>
  );
}
